import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-236b3954"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "appinfo" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "maindialog",
      style: _normalizeStyle({ backgroundImage: `url(${$setup.maitain})` })
    }, [
      _createElementVNode("img", {
        src: $setup.maitin,
        class: "mainlogo"
      }, null, 8 /* PROPS */, _hoisted_2),
      _createElementVNode("div", _hoisted_3, _toDisplayString($setup.annnotice), 1 /* TEXT */)
    ], 4 /* STYLE */),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        class: "logo",
        src: $setup.SVIP_ICON
      }, null, 8 /* PROPS */, _hoisted_5),
      _createElementVNode("div", _hoisted_6, _toDisplayString($setup.appName), 1 /* TEXT */)
    ])
  ]))
}